export class Stores {
   public Id: number;
   public StoreName: string;
   public StoreCode: string
}
